import React, { useMemo, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useLanguage } from '../../../../contexts/LanguageContext';
import useTrainingReportInstructorsData from '../hooks/useTrainingReportInstructorsData';
import InstructorUserDropdown from '../../components/InstructorUserDropdown';

/**
 * Rapor detayındaki eğitmen ataması. `PlanningInstructorsTab.jsx` ile aynı desen.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md §6.
 */
const TrainingReportInstructorsTab = ({ trainingReportId, readOnly = false }) => {
    const { th } = useLanguage();
    const { instructorsApi, isLoading, isAdding, isDeleting, addInstructor, removeInstructor } = useTrainingReportInstructorsData(trainingReportId);
    const [selectedUserId, setSelectedUserId] = useState(null);

    const instructors = useMemo(() => instructorsApi?.items || [], [instructorsApi]);
    const assignedUserIds = useMemo(() => instructors.map((row) => row.userId), [instructors]);

    const handleAdd = async () => {
        if (!selectedUserId) return;
        const success = await addInstructor(selectedUserId);
        if (success) setSelectedUserId(null);
    };

    const handleRemove = (row) => {
        confirmDialog({
            message: th('trainingReport.instructors.confirmDeleteMessage'),
            header: th('common.delete'),
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => removeInstructor(row.id)
        });
    };

    const actionBodyTemplate = (row) => <i className="pi pi-trash cursor-pointer text-red-500 hover:text-red-700" style={{ fontSize: '1.1rem' }} title={th('common.delete')} onClick={() => handleRemove(row)} />;

    return (
        <div>
            <ConfirmDialog />
            {!readOnly && (
                <div className="flex align-items-end gap-2 mb-3">
                    <div style={{ minWidth: '20rem' }}>
                        <label className="block mb-1">{th('trainingReport.instructors.selectUser')}</label>
                        <InstructorUserDropdown value={selectedUserId} onChange={setSelectedUserId} excludeUserIds={assignedUserIds} placeholder={th('trainingReport.instructors.selectUserPlaceholder')} className="w-full" />
                    </div>
                    <Button label={th('trainingReport.instructors.addButton')} icon="pi pi-plus" onClick={handleAdd} disabled={!selectedUserId} loading={isAdding} />
                </div>
            )}

            <DataTable value={instructors} loading={isLoading || isDeleting} dataKey="id" emptyMessage={th('trainingReport.instructors.emptyMessage')} className="p-datatable-gridlines" showGridlines>
                {!readOnly && <Column body={actionBodyTemplate} style={{ width: '4rem' }} align="center" />}
                <Column field="userId" header={th('trainingReport.instructors.columnUserId')} style={{ width: '8rem' }} />
                <Column field="userFullName" header={th('trainingReport.instructors.columnUserFullName')} />
                <Column field="userEmail" header={th('trainingReport.instructors.columnUserEmail')} />
            </DataTable>
        </div>
    );
};

export default TrainingReportInstructorsTab;
